import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import Grid from '@mui/material/Grid';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import SearchIcon from '@mui/icons-material/Search';

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function ReelsEdit(props) {
    //console.debug("RTS Break ReelsEdit");

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const {user, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const history = useNavigate();
    //const display = props.display;
    const mode = props.mode;
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");
    const [showReelTypeLookup, setShowReelTypeLookup] = useState(false);
    const [showTrackerLookup, setShowTrackerLookup] = useState(false);
    const [showSequenceModal, setShowSequenceModal] = useState(false);
    const [showRemoveTrackerModal, setShowRemoveTrackerModal] = useState(false);
    const [removeReel, setRemoveReel] = useState(null);

    const [idGuid, setIdGuid] = useState("00000000-0000-0000-0000-000000000000");
    const [reelType, setReelType] = useState(null);
    const [tracker, setTracker] = useState(null);
    const [status, setStatus] = useState('Disabled(0)');
    const [serialNumber, setSerialNumber] = useState('');
    const [idSap, setIdSap] = useState('');

    
    const fetchData = useCallback((idGuid) => {
        let apiURL = apiRoot + "/Reels/GetReelById/" + idGuid;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);

                setIdGuid(response.data.idGuid)
                setReelType(response.data.reelType);
                setTracker(response.data.tracker);
                setStatus(response.data.status===1?'Active(1)':'Disabled(0)');
                setSerialNumber(response.data.serialNumber!==null?response.data.serialNumber:'');
                setIdSap(response.data.idSap!==null?response.data.idSap:'');
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]);

    
    useEffect(() => {
        if(mode === 1){
            fetchData(props.idGuid);
        }
        else{
            setIsLoading(false);
        }

    },[mode, fetchData, props.idGuid]);  


    function getStatusVal(){
        if(status===1){
            return "Active(1)";
        }
        else{
            return "Disabled(0)";
        }
    }


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };    


    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Box>
            <Box id="reelForm">
                <Box id="mdBox" maxWidth="md" sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Box id="smBox" maxWidth="sm" sx={{width:smallForm?'auto':'600px'}}>
                <TextField
                    id="tbSerialNumber"
                    margin="normal"
                    fullWidth
                    label="Serial Number"
                    size="small"
                    required
                    disabled
                    value={serialNumber}
                />                                               
                <Box sx={{display:'flex', alignItems:'center', width:'100%'}}>
                    <TextField
                        id="tbReelType"
                        margin="normal"
                        fullWidth
                        label="ReelType"
                        size="small"
                        required
                        disabled
                        value={reelType==null?'':reelType.name}
                    />
                </Box>
                <Box sx={{display:'flex', alignItems:'center', width:'100%'}}>
                    <TextField
                        id="tbTracker"
                        margin="normal"
                        fullWidth
                        label="Tracker"
                        size="small"
                        disabled
                        value={tracker==null?'':tracker.esn}
                    />
                </Box>
                <Grid container>
                    <Grid item xs={12} sm={6} sx={{display:"flex", justifyContent:"start", alignItems:"center"}}>
                        <Typography sx={{fontSize:'.75em'}}>Last Check In:</Typography>
                        <Typography sx={{fontSize:'.75em', pl:1}}>{tracker!=null?tracker.lastUpdate!=null?format(parseISO(tracker.lastUpdate), "MM-dd-yyyy"):'':''}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} sx={{display:"flex", justifyContent:{xs:"start", sm:"end"}, alignItems:"center"}}>
                        <Typography sx={{fontSize:'.75em'}}>Battery Level:</Typography>
                        <Typography sx={{fontSize:'.75em', pl:1}}>{tracker!=null?tracker.batteryLevel!=null?tracker.batteryLevel!=='-1'?tracker.batteryLevel+"%":'Unknown':'Unknown':''}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} sx={{display:"flex", justifyContent:{xs:"start", sm:"center"}, alignItems:"center", mt:1}}>
                        <Typography sx={{fontSize:'.75em'}}>Sequence Id:</Typography>
                        <Typography sx={{fontSize:'.75em', pl:1}}>{tracker!=null?tracker.idSeq!=null?tracker.idSeq:'-1':''}</Typography>
                    </Grid>
                </Grid>
                <Box sx={{display:'flex', alignItems:'center', width:'100%'}}>
                    <TextField
                        id="tbStatus"
                        margin="normal"
                        fullWidth
                        label="Status"
                        size="small"
                        disabled
                        value={status}
                    />
                </Box>
                </Box>
                </Box>
            </Box>
        </Box>
        </>
    );
}
